import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { VERSION as VERSION_ALAIN } from '@delon/theme';
import { NzModalService, VERSION as VERSION_ZORRO } from 'ng-zorro-antd';
import { filter } from 'rxjs/operators';
import { Spinkit } from 'ng-http-loader';

@Component({
  selector: 'app-root',
  template: `
    <ng-http-loader
      [filteredHeaders]="ignoreHeaders"
      [spinner]="spinkit.skThreeBounce"
      [backgroundColor]="'#333333'"
      [debounceDelay]="0"
      [minDuration]="500"
    ></ng-http-loader>
    <router-outlet></router-outlet>
    <notifier-container></notifier-container>
  `,
})
export class AppComponent implements OnInit {
  public spinkit: any = Spinkit;
  public ignoreHeaders: string[] = ['Ignore-Loading'];

  constructor(el: ElementRef, renderer: Renderer2, private router: Router, private modalSrv: NzModalService) {
    renderer.setAttribute(el.nativeElement, 'ng-alain-version', VERSION_ALAIN.full);
    renderer.setAttribute(el.nativeElement, 'ng-zorro-version', VERSION_ZORRO.full);
  }

  ngOnInit() {
    this.router.events.pipe(filter(evt => evt instanceof NavigationEnd)).subscribe(() => {
      this.modalSrv.closeAll();
    });
  }
}
